import $ from 'jquery';

function Stripper(element) {
  this.$element = $(element);
  this.strip();
}

Stripper.prototype = {
  strip() {
    this.$element.children().unwrap();
  },
};

export default Stripper;



// WEBPACK FOOTER //
// ./Strip.js